import type { BaseResponse } from "~/@types";
import { http } from "~/libs/axios";

export type UpgradeRequestStatus = "pending" | "approved" | "rejected";

export interface UpgradeRequest {
  _id: string;
  currentLevel: number;
  targetLevel: number;
  status: UpgradeRequestStatus;
  note?: string | null; // catatan admin, tampil saat status rejected
  reviewedAt?: string | null;
  createdAt: string;
}

type UpgradeListResponse = BaseResponse & { data: UpgradeRequest[] };
type UpgradeResponse = BaseResponse & { data: UpgradeRequest };

export const upgrade = {
  // Riwayat pengajuan kenaikan kelas milik user.
  getMine: () => http<UpgradeListResponse>("GET", { url: "/upgrade-request/mine" }),

  // Ajukan kenaikan kelas. Backend menolak (400) bila sudah level tertinggi,
  // checklist belum 100%, atau masih ada pengajuan berstatus pending.
  submit: () => http<UpgradeResponse>("POST", { url: "/upgrade-request" }),
};
